// extracted by mini-css-extract-plugin
export var loadingSpinner = "_28-0";
export var spinnerContainer = "_28-1";